var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2135.3px",
    height: "3008.6px",
    viewBox: "0 0 2135.3 3008.6",
    style: {
      enableBackground: "new 0 0 2135.3 3008.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EFEFEF;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#DD3A3A;}\r\n\t.st3{fill:#231815;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.8,103.6l290.6-61.1c1.4-0.3,2.8,0.8,2.8,2.3V2964c0,1.5-1.3,2.6-2.8,2.4l-290.1-45.6 c-4.1-0.6-7.1-4.2-7.1-8.3V111.9C64.1,107.9,66.9,104.4,70.8,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2071.2,189.3v2579.3c0,2.8-2.1,5.2-4.8,5.6L366.9,2966.4c-1.5,0.2-2.8-0.9-2.8-2.4V44.4 c0-1.3,1.1-2.4,2.5-2.3L2066,183.7C2068.9,183.9,2071.2,186.3,2071.2,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2071.2,2773.7l-1707,192.7l-300.1-46.7V1873.9l300.1,36.4l1707.1-106.9v970.3H2071.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2066.8,173.7L367.5,32.1h-0.1c-1.4-0.1-2.8,0.1-4.1,0.4c-1.3-0.1-2.6-0.1-3.9,0.2L68.8,93.8 c-8.5,1.8-14.6,9.4-14.6,18v1750.8v1049.7v15.9l78.3,12.2l227.5,35.7c0.6,0.1,1.3,0.2,1.9,0.2c0.4,0,0.7,0,1.1,0l1.1,0.2l1.4-0.2 c0.4,0,0.8,0.1,1.3,0.1s1,0,1.6-0.1L1474,2851.2l607.4-68.6v-14.1v-975.7V189.3C2081.2,181.1,2074.9,174.3,2066.8,173.7z  M1470.6,2831.4L374.2,2955.2V1919.8l1687.1-105.6v950.5L1470.6,2831.4z M74.1,2911.1V1885.2l280.1,34v1035.5L135,2920.6 L74.1,2911.1z M74.1,113.1l280.1-58.9v1844.9l-280.1-34C74.1,1865.1,74.1,113.1,74.1,113.1z M374.2,1899.7V52.7l1687.1,140.6 v1600.8L374.2,1899.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.846fdb7d24bb92c99926c54230c6924c.svg";
export { ForwardRef as ReactComponent };